import React from "react";

// Chat-bubble glyph for the mobile Wheel View "Comments" tab. Accepts the same
// { color, width, height } contract as the other tab glyphs (assets/icons).
const CommentIcon = ({ color = "#5A1B97", width = 28, height = 28 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8.5C4 5.46243 6.46243 3 9.5 3H18.5C21.5376 3 24 5.46243 24 8.5V14.5C24 17.5376 21.5376 20 18.5 20H11.4142L7.20711 24.2071C6.57714 24.8371 5.5 24.391 5.5 23.5V19.6586C4.60771 18.6822 4 17.3697 4 15.9V8.5Z"
      fill={color}
    />
    <path
      d="M9 9.5H19"
      stroke="#F6F7F9"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M9 13.5H15.5"
      stroke="#F6F7F9"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export default CommentIcon;
